import { createTRPCReact } from "@trpc/react-query";

import type { AppRouter } from "@atalan/api";

export const api = createTRPCReact<AppRouter>();

export { type RouterInputs, type RouterOutputs } from "@atalan/api";
